<template>
  <FlexColumn>
    <Label bold text="経験のある言語・データ・ツール" />
    <FlexRow wrap class="chips">
      <Chip
          v-for="(label, index) in languageLabels"
          :key="`language-${index}`"
          size="small"
          color="language"
          label outlined no-bold un-clickable
      >
        {{label}}
      </Chip>
      <Chip
          v-for="(label, index) in dataLabels"
          :key="`data-${index}`"
          size="small"
          color="data"
          label outlined no-bold un-clickable
      >
        {{label}}
      </Chip>
      <Chip
          v-for="tool in toolLabels"
          :key="`tools-${tool}`"
          size="small"
          color="tool"
          label outlined no-bold un-clickable
      >
        {{tool}}
      </Chip>
    </FlexRow>
  </FlexColumn>
</template>

<script>
import FlexColumn from "@/components/atoms/FlexColumn";
import Label from "@/components/atoms/Label";
import Chip from "@/components/atoms/Chip";
import FlexRow from "@/components/atoms/FlexRow";
import {mapGetters} from "vuex";

export default {
  name: "ApplicantServicesTools",
  components: { FlexRow, Chip, Label, FlexColumn},
  props: {
    applicant: {
      type: Object
    }
  },
  data() {
    return {
      languageLabels: [],
      dataLabels: [],
      toolLabels: []
    }
  },
  computed: {
    ...mapGetters('system', ['consts']),
  },
  methods: {
    initLabels() {
      let count = 0
      const max = 200
      if (this.consts && this.consts.programmingLanguages && this.consts.dataGoodAt && this.consts.userServiceAndTool)  {
        for (const value of this.applicant.skills.languages) {
          if (count > max) {
            return
          }
          const label = this.consts.programmingLanguages.find(item => item.value === value).label
          count += label.length
          this.languageLabels.push(label)
        }
        for (const value of this.applicant.skills.data) {
          if (count > max) {
            return
          }
          const label = this.consts.dataGoodAt.find(item => item.value === value).label
          count += label.length
          this.dataLabels.push(label)
        }
        for (const value of this.applicant.skills.tools) {
          if (count > max) {
            return
          }
          const label = this.consts.userServiceAndTool.find(item => item.value === value).label
          count += label.length
          this.toolLabels.push(label)
        }
      }
    }
  },
  watch: {
    consts: {
      handler() {
        this.initLabels()
      },
      immediate: true
    }
  }
}
</script>

<style scoped>
.chips .v-chip {
  margin-bottom: 4px;
}
</style>